<template>
    <v-row dense>
        <v-col cols="12" sm="12">
            <v-card
                class="pa-0 rounded-0 elevation-0"
                :class="
                    $vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                "
            >
                <ul class="ma-0 px-4 py-4 d-flex justify-space-between flex-wrap">
                    <li
                        class="d-flex flex-column"
                        v-for="list in lists"
                        :key="list.id"
                    >
                        <span class="text--ash">{{ list.title }}</span>
                        <span>{{ list.amount }}</span>
                    </li>
                </ul>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ALLACCOUNTSSUMMARY__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            lists: [],
        };
    },
    computed: {
        ...mapState("accountsummary", ["accountsummary"]),
    },
    methods: {
        ...mapActions("accountsummary", [
            ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY,
        ]),
        generateListsFromAccountSummary() {
            this.lists = [];
            if (this.accountsummary) {
                this.lists.push(
                    {
                        id: 1,
                        title: "Total Deposit($)",
                        amount: this.accountsummary?.totalDeposit,
                    },
                    {
                        id: 2,
                        title: "Total Withdraw($)",
                        amount: this.accountsummary?.totalWithdrawal,
                    },
                    // {
                    //     id: 3,
                    //     title: "Total Lots (Cent + Usd)",
                    //     amount: this.accountsummary?.totalLots,
                    // },
                    {
                        id: 4,
                        title: "Total Commission($)",
                        amount: this.accountsummary?.totalCommission,

                    },
                    {
                        id: 5,
                        title: "Total Trading Acc.",
                        amount: this.accountsummary?.totalTradingAccounts,
                    },
                    {
                        id: 6,
                        title: "Total Clients Acc.",
                        amount: this.accountsummary?.totalClients,
                    }
                );
            }
        },
    },
    mounted() {
        this[ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY]();
        this.generateListsFromAccountSummary();
    },
    watch: {
        accountsummary: {
            handler() {
                this.generateListsFromAccountSummary();
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.info-mt5{
    font-size: 12px;
    background: transparent !important;
    padding-bottom: 50px;
    margin-left: 5px;
    opacity: .8;
}

.text-green{
    color: rgb(73, 221, 134);
}

.text-danger{
    color: rgb(255, 67, 33);
}
</style>